export const TAG_PREFIX = "k6load-";
export const MIN_POOL_SIZE = 1;
export const MAX_POOL_SIZE = 200;

const LABEL_PATTERN = /^[A-Za-z0-9-]+$/;
const WHOLE_NUMBER_PATTERN = /^\d+$/;

export function validateLabel(label: string): string | undefined {
  if (label.length === 0) return "Enter a label for the tag.";
  if (!LABEL_PATTERN.test(label)) return "Use letters, digits and hyphens only.";
  return undefined;
}

export function validateSize(size: string): string | undefined {
  const value = Number(size);
  if (!WHOLE_NUMBER_PATTERN.test(size) || value < MIN_POOL_SIZE || value > MAX_POOL_SIZE) {
    return `Enter a whole number from ${MIN_POOL_SIZE} to ${MAX_POOL_SIZE}.`;
  }
  return undefined;
}
